import chartIcon from '@disy/cadenza-icons/chart.svg';
import dashboardIcon from '@disy/cadenza-icons/dashboard.svg';
import mapIcon from '@disy/cadenza-icons/map.svg';
import tableIcon from '@disy/cadenza-icons/table.svg';
import type { Icon } from '@disy/ui/icon';
import { icon } from '@disy/ui/icon';

import type { ViewType } from 'cadenza/workbook/api/view-type';

/** @see net/disy/cadenza/workbook/api/WorksheetIcon.java */
export type WorksheetIconType = Extract<ViewType, 'TABLE' | 'MAP' | 'CHART'> | 'MIXED';

const WORKSHEET_ICONS: Record<WorksheetIconType, string> = {
  TABLE: tableIcon,
  MAP: mapIcon,
  CHART: chartIcon,
  MIXED: dashboardIcon,
} as const;

export const WorksheetIconType = {
  icon: (worksheetIconType: WorksheetIconType): Icon => icon(WORKSHEET_ICONS[worksheetIconType]),
};
